<template>
  <div>
    <!-- Create Button -->
    <component-guard :requiredPermissions="['28.2']">
      <button class="btn btn-create" @click="openModal">
        <i class="fa fa-plus"></i>
        <span class="ml-2">Buat Baru</span>
      </button>
    </component-guard>

    <!-- Modal -->
    <div
      class="modal fade"
      id="typePromptModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content custom-modal">
          <!-- Header -->
          <div class="modal-header border-0 pb-2">
            <div>
              <h4 class="modal-title font-weight-bold">Buat Baru</h4>
              <small class="text-muted">
                Pilih jenis Pembaruan Order yang ingin dilakukan
              </small>
            </div>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="selectedType = ''"
            >
              <span>&times;</span>
            </button>
          </div>

          <hr class="m-0" />

          <!-- Body -->
          <div class="modal-body">
            <!-- Option 1 -->
            <div
              class="option-card mb-3"
              :class="{ active: selectedType === 'change-name' }"
              @click="selectedType = 'change-name'"
            >
              <div class="custom-control custom-radio">
                <input
                  type="radio"
                  class="custom-control-input"
                  id="changeName"
                  value="change-name"
                  v-model="selectedType"
                />

                <label class="custom-control-label w-100" for="changeName">
                  <div class="font-weight-bold">Perubahan Nama Lessee</div>

                  <small class="text-muted">
                    Gunakan jika perusahaan penyewa yang sama hanya berganti
                    nama legal/badan hukum baru.
                  </small>
                </label>
              </div>
            </div>

            <!-- Option 2 -->
            <div
              class="option-card"
              :class="{ active: selectedType === 'transfer-unit' }"
              @click="selectedType = 'transfer-unit'"
            >
              <div class="custom-control custom-radio">
                <input
                  type="radio"
                  class="custom-control-input"
                  id="transferUnit"
                  value="transfer-unit"
                  v-model="selectedType"
                />

                <label class="custom-control-label w-100" for="transferUnit">
                  <div class="font-weight-bold">Pengalihan Unit</div>

                  <small class="text-muted">
                    Gunakan jika unit ingin dipindahtangankan ke
                    perusahaan/badan hukum yang sepenuhnya berbeda.
                  </small>
                </label>
              </div>
            </div>

            <!-- Alert -->
            <div class="alert custom-alert mt-4">
              <div class="d-flex">
                <div class="mr-2">
                  <img
                    src="@/assets/icon/warning-triangle-brown.svg"
                    alt="warning"
                  />
                </div>

                <div>
                  <div class="font-weight-bold text-warning-dark">
                    Penting untuk Diketahui
                  </div>

                  <div class="small text-warning-dark">
                    Setiap pengajuan Pembaruan Order akan menghentikan (cut-off)
                    nomor order berjalan dan otomatis akan menerbitkan nomor
                    order serta perjanjian baru setelah verifikasi selesai.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer">
            <button
              class="btn btn-outline-secondary px-4"
              data-dismiss="modal"
              @click="selectedType = ''"
            >
              Kembali
            </button>

            <button class="btn btn-primary px-4" @click="next">
              Lanjutkan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ComponentGuard } from "@/components/Permissions";

export default {
  name: "TypePrompt",
  components: {
    ComponentGuard,
  },

  data() {
    return {
      selectedType: "",
    };
  },

  methods: {
    next() {
      $("#typePromptModal").modal("hide");
      this.$router.push({
        path: "/rent-adjustment/create",
        query: { type: this.selectedType },
      });
    },

    openModal() {
      $("#typePromptModal").modal("show");
    },
  },
};
</script>

<style scoped>
.custom-modal {
  border-radius: 14px;
  overflow: hidden;
}

.modal-header {
  padding: 24px;
}

.modal-body {
  padding: 24px;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e9ecef;
}

/* Option Card */

.option-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 18px;
  cursor: pointer;
  transition: 0.2s;
}

.option-card:hover {
  border-color: #409eff;
}

.option-card.active {
  border: 1px solid #409eff;
  background: #f3f8ff;
}

.option-card .custom-control-label {
  cursor: pointer;
}

.option-card small {
  display: block;
  margin-top: 6px;
  line-height: 1.5;
}

/* Bootstrap radio spacing */

.custom-control {
  padding-left: 1.7rem;
}

.custom-control-label::before,
.custom-control-label::after {
  top: 3px;
}

/* Alert */

.custom-alert {
  background: #fff9e8;
  border: 1px solid #ffd77a;
  border-radius: 8px;
  margin-bottom: 0;
}

.text-warning-dark {
  color: #b45309;
}

/* Button */

.btn-primary {
  border-radius: 6px;
  padding: 8px 22px;
}

.btn-outline-secondary {
  border-radius: 6px;
}

.close {
  outline: none;
}

.modal-title {
  font-size: 28px;
}

.btn-create {
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  background-color: #247fec;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  width: fit-content;
}

.btn-create i {
  width: 20px;
  height: 20px;
}

.btn-create:hover {
  background-color: #1a5db8;
  display: flex;
  align-items: center;
  gap: 4px;
}

.btn-create p {
  font-size: 26px;
  margin: 0;
}

/* Hide default bootstrap style */
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: none;
}

/* Outer circle */
.custom-radio .custom-control-label::before {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid #4c51568a;
  background: #fff;
  top: 0;
  left: -30px;
}

/* Checked outer circle */
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #2f80ed;
  background: #fff;
}

/* Inner circle */
.custom-radio .custom-control-label::after {
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: transparent;
  top: 5px;
  left: -25px;
  transition: 0.2s;
}

/* Checked inner circle */
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background: #2f80ed;
}

/* Optional hover */
.custom-radio:hover .custom-control-label::before {
  border-color: #2f80ed;
}

/* Focus */
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none;
}
</style>


// WEBPACK FOOTER //
// src/components/RentAdjustment/CustomComponent/TypePrompt.vue